"use strict";
const axios = require("axios");
const { abstractResource } = require("./abstractResource");

const service = abstractResource("ATS");

const Recruitment = {
  ...service("recruitments"),
  get_form_recruitment() {
    return {
      company: "quentin-grange",
      state: "sketch",
      new: [],
      cv_selected: [],
      interview_by_phone: [],
      interview_made: [],
      offer_made: [],
      cvtechs: [],
      company_name: null,
      site_url: null,
      company_desc: null,
      job_name: null,
      city: null,
      contract_type: null,
      post_description: null,
      candidate_profile: null,
      pipeline: null,
      archived: false,
      interview: null,
      assigned_users: [],
      level_of_study: null,
      experience: null,
      postal_code: null,
      street_address: null,
      referent_user: null,
    };
  },

  get_recruitment_info() {
    return {
      nameRecruitment: null,
      idRecruitment: null,
      idPipeline: null,
      contract_type: null,
      city: null,
      state: null,
      name_step_one: null,
      name_step_two: null,
      name_step_three: null,
      name_step_four: null,
      name_step_five: null,
      name_step_six: null,
      name_step_seven: null,
      name_step_eight: null,
      name_step_nine: null,
      name_step_ten: null,
      length_step_one: null,
      length_step_two: null,
      length_step_three: null,
      length_step_four: null,
      length_step_five: null,
      length_step_six: null,
      length_step_seven: null,
      length_step_eight: null,
      length_step_nine: null,
      length_step_ten: null,
    };
  },

  get_recruitment_state_choice() {
    return [
      { value: "sketch", text: "Brouillon" },
      { value: "online", text: "En ligne" },
      { value: "offline", text: "Hors-ligne" },
    ];
  },

  get_recruitment_contract_choice() {
    return [
      { value: "cdi", text: "CDI" },
      { value: "cdd", text: "CDD" },
      { value: "interim", text: "Intérim" },
      { value: "freelance", text: "Freelance" },
      { value: "stage", text: "Stage" },
      { value: "alternancea", text: "Alternance (contrat d'apprentissage)" },
      { value: "alternancep", text: "Volontariat international en entreprise" },
      { value: "jetudiant", text: "Job étudiant" },
      { value: "franchise", text: "Franchisé" },
      { value: "statutaire", text: "Statutaire" },
      { value: "intermittent", text: "Intermittent" },
      { value: "servicecivique", text: "Service civique" },
      { value: "cee", text: "Contrat d'engagement éducatif" },
    ];
  },

  get_recruitment_experience_choice() {
    return [
      { value: "one_to_three", text: "Entre 1 et 3 ans d'expérience" },
      { value: "three_to_six", text: "Entre 3 et 6 ans d'expèrience" },
      { value: "six_to_nine", text: "Entre 6 et 9 ans d'expérience" },
      { value: "more_than_nine", text: "Plus de 9 ans d'expérience" },
    ];
  },

  get_recruitment_level_of_study_choice() {
    return [
      { value: "none", text: "Aucun Diplôme" },
      { value: "bep", text: "BEP, CAP ou équivalent" },
      { value: "bac", text: "Baccalauréat" },
      { value: "bac+2", text: "DUT,BTS, Diplôme d'état ou équivalent" },
      { value: "bac+3", text: "Licence, Bachelor ou équivalent" },
      { value: "bac+4", text: "Master 1 ou équivalent" },
      { value: "bac+5", text: "Master, Diplôme d'ingénieur ou équivalent" },
      { value: "bac+8", text: "Doctorat ou équivalent" },
    ];
  },

  // summary : Function that return a list that contains all your recruitments
  // params : - request : url of your request

  async get_non_archived_recruitments_public() {
    return this.get({ archived: false, state: "online" }, { via: "public" });
  },

  async get_non_archived_recruitments() {
    let recruitments;
    let rows;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitments/",
    })
      .then((response) => {
        recruitments = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [recruitments, rows];
  },

  async get_recruitment(id) {
    let form;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitments/?id=" + id,
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  async get_recruitment_public(id) {
    let form;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitments/?id=" + id,
      headers: {
        via: "public",
      },
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  // summary : Function that edit a recruitment
  // params : - id : recruitment that we want to uptade
  //          - form_recruitment : form that wontain new informations

  async edit_recruitment(id, formRecruitment) {
    return this.edit(id, formRecruitment);
  },
};

const Cvtech = {
  ...service("cvtechs"),
  get_form_cvtech() {
    return {
      created_by: null,
      civility: null,
      first_name: null,
      last_name: null,
      adress: null,
      email: null,
      phone: null,
      experience: null,
      level_of_study: null,
      salary: null,
      availability: null,
      candidate_profile: null,
      source: null,
      source_detail: null,
      grades: [],
      grade_counter: 0,
      notes: [],
      state: null,
      linkedin_link: null,
      interview_date_begin: null,
      interview_date_end: null,
      link_interview_recruitment: null,
      link_recruitments: [],
      new: [],
      cv_selected: [],
      interview_by_phone: [],
      interview_made: [],
      offer_made: [],
      recruitment: [],
      our_cv: true,
      actions: [],
      insterviews: [],
      work_address: null,
      type_of_work: null,
      activity_area: null,
      strong_points: [],
      profession: null,
      speciality: null,
      archived: false,
      student: false,
      id_card_type: null,
      id_card_validity: null,
      managers: [],
    };
  },
  get_civility_choices() {
    return [
      { value: "man", text: "Monsieur" },
      { value: "woman", text: "Madame" },
    ];
  },

  get_profession_choices() {
    return [
      { value: "audit", text: "Audit / Finance / Assurance" },
      { value: "business", text: "Business" },
      { value: "conseil", text: "Conseil" },
      { value: "cre", text: "Crea" },
      { value: "resto", text: "Hôtellerie / Restauration" },
      { value: "immo", text: "Immobilier" },
      { value: "industrie", text: "Industrie" },
      { value: "marketing", text: "Marketing / Communication" },
      { value: "media", text: "Media" },
      { value: "mode", text: "Metiers de la mode" },
      { value: "relclient", text: "Relation Client" },
      { value: "retail", text: "Retail" },
      { value: "sante", text: "Santé / Médical / Social" },
      { value: "support", text: "Support" },
      { value: "tech", text: "Tech" },
      { value: "tourisme", text: "Tourisme" },
    ];
  },

  get_audit_specialities() {
    return [
      { value: "corpfinance", text: "Coroprate Finance" },
      { value: "finandemarch", text: "Finance de marché" },
      { value: "conseil", text: "Conseil" },
      {
        value: "transactionserv",
        text: "Audit / Consolidation / Transaction Services",
      },
      { value: "investissement", text: "Fond d'investissement" },
      { value: "actuariat", text: "Actuariat" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_business_specialities() {
    return [
      { value: "commecrial", text: "Commercial" },
      { value: "businessdev", text: "Business Development" },
      { value: "accmanagement", text: "Account Management" },
      { value: "acheteur", text: "Acheteur" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_conseil_specialities() {
    return [
      { value: "digital", text: "Digital" },
      { value: "moait", text: "MOA / IT" },
      { value: "management", text: "Management / Organisation" },
      { value: "strategie", text: "Stratégie" },
      { value: "innovation", text: "Innovation" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_cre_specialities() {
    return [
      { value: "ux", text: "UX Design" },
      { value: "graphisme", text: "Graphisme / Illustration" },
      { value: "ui", text: "UI Design" },
      { value: "production", text: "Production audivisuelle" },
      { value: "dircrea", text: "Direction créative" },
      { value: "motiondesign", text: "Motion Design" },
    ];
  },

  get_resto_specialities() {
    return [
      { value: "cuisine", text: "Cuisine" },
      { value: "salle", text: "Salle" },
      { value: "reception", text: "Réception" },
      { value: "etages", text: "Etages" },
      { value: "patisserie", text: "Pâtisserie" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_immo_specialities() {
    return [
      { value: "negociateur", text: "Négociateur" },
      { value: "conseilfinance", text: "Conseiller financier" },
      { value: "respotravaux", text: "Responsable de travaux" },
      { value: "gestionnaire", text: "Gestionnaire" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_industrie_specialities() {
    return [
      { value: "techmaintenance", text: "Technicien de maintenance" },
      { value: "techproduction", text: "Technicien de production" },
      { value: "ouvrier", text: "Ouvrier" },
      { value: "opproduction", text: "Opérateur de production" },
      { value: "respoproduction", text: "Responsable de production" },
      { value: "respoqual", text: "Responsable de qualité" },
      { value: "resporegl", text: "Responsable réglementaire" },
      { value: "dirproduction", text: "Directeur de production" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_marketing_specialities() {
    return [
      { value: "marketing", text: "Marketing" },
      { value: "communication", text: "Communication" },
      { value: "commanagement", text: "Community Management / Social Media" },
      { value: "seo", text: "SEO / SEM" },
      { value: "traffic", text: "Traffic Management" },
      { value: "marketingop", text: "Marketing opérationnel" },
      { value: "marketingstrat", text: "Marketing stratégique" },
      { value: "marketingdev", text: "Marketing développement" },
      { value: "evenementiel", text: "Evénementiel" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_media_specialities() {
    return [
      { value: "redacteur", text: "Rédacteur" },
      { value: "gestionproj", text: "Gestion de projet" },
      { value: "journaliste", text: "Journaliste" },
      { value: "planningstat", text: "Planning stratégique" },
      { value: "attache", text: "Attaché de presse" },
      { value: "planningmed", text: "Planning média" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_mode_specialities() {
    return [
      { value: "styliste", text: "Styliste" },
      { value: "achats", text: "Achats" },
      { value: "chefprod", text: "Chef de produit" },
      { value: "modeliste", text: "Modéliste" },
      { value: "confection", text: "Confection" },
      { value: "dirart", text: "Directeur artistique" },
      { value: "dircol", text: "Directeur de collection" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_relclient_specialities() {
    return [
      { value: "support", text: "Support / Service client" },
      { value: "customer", text: "Customer Success" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_retail_specialities() {
    return [
      { value: "consvente", text: "Conseiller de vente" },
      { value: "logistique", text: "Logistique / Achats" },
      { value: "lanager", text: "Manager des ventes" },
      { value: "dirmaga", text: "Visual Merchandising" },
      { value: "visual", text: "Magasigner" },
      { value: "magasigner", text: "Responsable de formation" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_sante_specialities() {
    return [
      { value: "medecin", text: "Médecin" },
      { value: "aide", text: "Aide-soignant" },
      { value: "infirmier", text: "Infirmier" },
      { value: "auxiliaire", text: "Auxiliaire de vie sociale" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_support_specialities() {
    return [
      { value: "operation", text: "Opérations" },
      { value: "devrh", text: "Développement RH / Formation" },
      { value: "recrutement", text: "Recrutement" },
      { value: "comptabilite", text: "Comptabilité" },
      { value: "juridique", text: "Juridique" },
      { value: "servgen", text: "Services généraux / Office Management" },
      { value: "secretariat", text: "Secrétatiat" },
      { value: "controlegest", text: "Contrôle de gestion" },
      { value: "dirfinance", text: "Direction financière" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_tech_specialities() {
    return [
      { value: "devfull", text: "Dev Fullstack" },
      { value: "project", text: "Projet / Product Management" },
      { value: "devback", text: "Dev Backend" },
      { value: "devops", text: "DevOps / Infra" },
      { value: "r&d", text: "Recherche / R&D" },
      { value: "telecom", text: "Télécoms / Réseaux" },
      { value: "devfront", text: "Dev Frontend " },
      { value: "dataeng", text: "Data Engineering" },
      { value: "datascience", text: "Data Science" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_tourisme_specialities() {
    return [
      { value: "techvoyage", text: "Technicien voyages" },
      { value: "transports", text: "Transports" },
      { value: "production", text: "Production" },
      { value: "consvoyage", text: "Conseiller voyages" },
      { value: "autre", text: "Autre" },
    ];
  },

  get_level_of_study_choice() {
    return [
      { value: "none", text: "Aucun Diplôme" },
      { value: "bep", text: "BEP, CAP ou équivalent" },
      { value: "bac", text: "Baccalauréat" },
      { value: "bac_2", text: "DUT,BTS, Diplôme d'état ou équivalent" },
      { value: "bac_3", text: "Licence, Bachelor ou équivalent" },
      { value: "bac_4", text: "Master 1 ou équivalent" },
      { value: "bac_5", text: "Master, Diplôme d'ingénieur ou équivalent" },
      { value: "bac_8", text: "Doctorat ou équivalent" },
    ];
  },

  get_experience_choice() {
    return [
      { value: "one_to_three", text: "Entre 1 et 3 ans d'expérience" },
      { value: "three_to_six", text: "Entre 3 et 6 ans d'expèrience" },
      { value: "six_to_nine", text: "Entre 6 et 9 ans d'expérience" },
      { value: "more_than_nine", text: "Plus de 9 ans d'expérience" },
    ];
  },

  get_salary_choice() {
    return [
      { value: "10_to_20", text: "Entre 10000 à 20000 brut annuel" },
      { value: "20_to_30", text: "Entre 20000 à 30000 brut annuel" },
      { value: "30_to_40", text: "Entre 30000 à 40000 brut annuel" },
      { value: "40_to_50", text: "Entre 40000 à 50000 brut annuel" },
      { value: "50_to_60", text: "Entre 50000 à 60000 brut annuel" },
      { value: "60_to_70", text: "Entre 60000 à 70000 brut annuel" },
      { value: "70_to_80", text: "Entre 70000 à 80000 brut annuel" },
      { value: "80_to_90", text: "Entre 80000 à 90000 brut annuel" },
      { value: "90_to_100", text: "Entre 90000 à 100000 brut annuel" },
      { value: "100_to_110", text: "Entre 100000 à 110000 brut annuel" },
      { value: "110_to_120", text: "Entre 111000 à 120000 brut annuel" },
    ];
  },

  get_grade_choice() {
    return [
      { value: 1, text: "Un" },
      { value: 2, text: "Two" },
      { value: 3, text: "Three" },
      { value: 4, text: "Four" },
      { value: 5, text: "Five" },
    ];
  },

  get_contract_choice() {
    return [
      { value: "cdi", text: "CDI" },
      { value: "cdd", text: "CDD" },
      { value: "interim", text: "Intérim" },
      { value: "freelance", text: "Freelance" },
      { value: "stage", text: "Stage" },
      { value: "alternancea", text: "Alternance (contrat d'apprentissage)" },
      { value: "alternancep", text: "Volontariat international en entreprise" },
      { value: "jetudiant", text: "Job étudiant" },
      { value: "franchise", text: "Franchisé" },
      { value: "statutaire", text: "Statutaire" },
      { value: "intermittent", text: "Intermittent" },
      { value: "servicecivique", text: "Service civique" },
      { value: "cee", text: "Contrat d'engagement éducatif" },
    ];
  },

  get_activity_area_choices() {
    return [
      { value: "achats", text: "Achats" },
      { value: "admin", text: "Administratif" },
      { value: "secretariat", text: "Secrétariat" },
      { value: "commercial", text: "Commercial/Ventes" },
      { value: "com", text: "Communication/Documentation" },
      { value: "direction", text: "Direction générale" },
      { value: "maintenance", text: "Maintenance/Entretient" },
      { value: "finance", text: "Finance/Gestion/Comptabilité" },
      { value: "it", text: "Informatique" },
      { value: "juridique", text: "Juridique" },
      { value: "logistique", text: "Logistique" },
      { value: "marketing", text: "Marketing" },
      { value: "methods", text: "Méthodes" },
      { value: "prod", text: "Production" },
      { value: "qualite", text: "Qualité/Sécurité/Environnement" },
      { value: "recherche", text: "Recherche/Etudes et laboratoire" },
      { value: "sav", text: "Relation clients/Service après-vente" },
      { value: "rh", text: "Ressources humaines" },
      { value: "services", text: "Services généraux" },
    ];
  },

  get_source_choices() {
    return [
      { value: "job_site", text: "Site d'emploi" },
      { value: "career_site", text: "Site carrière" },
      { value: "sourcing", text: "Chasse/Sourcing" },
      { value: "import", text: "Sourcing externe" },
      { value: "other", text: "Autre" },
    ];
  },

  async get_cv_with_request(request) {
    let cvs;
    let rows;
    await axios({
      method: "get",
      url: request,
    })
      .then((response) => {
        cvs = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [cvs, rows];
  },

  async get_our_cvs(page) {
    let cvs;
    let rows;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API + "cvtechs" + "/?our_cv=true&page=" + page,
    })
      .then((response) => {
        cvs = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [cvs, rows];
  },

  async get_not_our_cvs(page) {
    let cvs;
    let rows;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API + "cvtechs" + "/?our_cv=false&page=" + page,
    })
      .then((response) => {
        cvs = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [cvs, rows];
  },

  async get_cvs(page) {
    let cvs;
    let rows;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtechs?page=" + page,
    })
      .then((response) => {
        cvs = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [cvs, rows];
  },

  async get_cvs_by_recruitment(id_recruitment, page) {
    let cvs;
    let rows;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "cvtechs/?recruitment=" +
        id_recruitment +
        "&page=" +
        page,
    })
      .then((response) => {
        cvs = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [cvs, rows];
  },

  async get_cv(id) {
    let form;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtechs" + "/?id=" + id,
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  async create_cv(form) {
    let cv_form;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "cvtechs/",
      data: form,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        cv_form = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return cv_form;
  },

  async create_cv_public(form) {
    let cv_form;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "cvtechs/",
      data: form,
      headers: {
        via: "public",
        "content-type": "application/json",
      },
    })
      .then((response) => {
        cv_form = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return cv_form;
  },

  async delete_cv(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "cvtechs/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_cv(id, form) {
    axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "cvtechs/" + id + "/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Report = {
  ...service("reports"),
}

const Recruitment_team = {
  ...service("recruitment-teams"),
  get_form_recruitment_team() {
    return {
      user: null,
      recruitment: null,
      company: null,
      first_name: null,
      last_name: null,
      email: null,
      notification_bool: false,
      email_bool: false,
      manager: false,
    };
  },

  async get_recruitment_team_by_recruitment_id(id) {
    let recruitment_team;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitment-teams/?recruitment=" + id,
    })
      .then((response) => {
        recruitment_team = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return recruitment_team;
  },

  async create_recruitment_team(form) {
    let recruitment_team_form;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "recruitment-teams/",
      data: form,
    })
      .then((response) => {
        recruitment_team_form = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return recruitment_team_form;
  },

  async edit_recruitment_team(id, form_recruitment_team) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "recruitment-teams/" + id + "/",
      data: form_recruitment_team,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_recruitment_team(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "recruitment-teams/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Pipeline = {
  ...service("pipelines"),

  get_form_pipeline() {
    return {
      states: null,
      recruitment: null,
      states_recruitment: null,
      pipeline_title: null,
    };
  },

  get_form_state_pipeline() {
    return {
      pipeline_title: null,
      number_recruitment: null,
      name_step_one: null,
      name_step_two: null,
      name_step_three: null,
      name_step_four: null,
      name_step_five: null,
      name_step_six: null,
      name_step_seven: null,
      name_step_eight: null,
      name_step_nine: null,
      number_step_nine: null,
      name_step_ten: null,
      number_step_ten: null,
    };
  },

  // summary : Function that return a list that contains all your pipelines
  // params : none

  async get_pipelines(page) {
    let pipelines;
    let rows;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipelines?page=" + page,
    })
      .then((response) => {
        pipelines = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [pipelines, rows];
  },
  async get_pipelines_with_request(request) {
    let pipelines;
    let rows;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipelines" + request,
    })
      .then((response) => {
        pipelines = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [pipelines, rows];
  },

  async get_pipelines_without_pages() {
    let pipelines;
    let rows;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipelines",
    })
      .then((response) => {
        pipelines = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [pipelines, rows];
  },

  async get_pipeline_with_title(title) {
    let form_pipeline;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipelines?pipeline_title=" + title,
    })
      .then((response) => {
        form_pipeline = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_pipeline;
  },

  async get_pipeline_with_id(id) {
    let form_pipeline;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipelines?id=" + id,
    })
      .then((response) => {
        form_pipeline = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_pipeline;
  },

  async get_pipeline_with_id_public(id) {
    let form_pipeline;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipelines/" + id,
      headers: {
        via: "public",
      },
    })
      .then((response) => {
        form_pipeline = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return form_pipeline;
  },

  async create_pipeline(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "pipelines/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_pipeline(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "pipelines/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Filter_recruitment = {
  ...service("filter-recruitments"),
  get_filter_recruitment() {
    return {
      state: false,
      job_name: false,
      contract_type: false,
      city: false,
      candidate_profile: false,
    };
  },

  // summary : Function that return a list that contains your filter
  // params : - request : url of your request

  async get_filter() {
    let filterRecruitment;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "filter-recruitments",
    })
      .then((response) => {
        filterRecruitment = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return filterRecruitment;
  },

  // summary : Function that edit a given filter
  // params : - id : filter that we want to edit
  //          - filterRecruitment : object that contain the filters

  async edit_filter(id, filterRecruitment) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "filter-recruitments/" + id + "/",
      data: filterRecruitment,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_filter(filterRecruitment) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "filter-recruitments/",
      data: filterRecruitment,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Apply = {
  ...service("applies"),

  get_form_apply() {
    const form = {
      company: "quentin-grange",
      recruitment: null,
      first_name_active: false,
      first_name_optionnal: false,
      first_name_position: null,
      last_name_active: false,
      last_name_optionnal: false,
      last_name_position: null,
      email_active: false,
      email_optionnal: false,
      email_position: null,
      phone_active: false,
      phone_optionnal: false,
      phone_position: null,
      social_networks_active: false,
      social_networks_optionnal: false,
      social_position: null,
      motivation_text_active: false,
      motivation_text_optionnal: false,
      motivation_position: null,
      cv_active: false,
      cv_optionnal: false,
      cv_position: null,
      level_of_study_active: false,
      level_of_study_optionnal: false,
      level_of_study_position: null,
      experience_active: false,
      experience_optionnal: false,
      experience_position: null,
      availability_active: false,
      availability_optionnal: false,
      availability_position: null,
      salary_active: false,
      salary_optionnal: false,
      salary_position: null,
    };
    return form;
  },

  get_form_possibilities() {
    return [
      {
        name: "Nom",
        back_name: "last_name_active",
        optionnal: false,
        form_picture: "mdi mdi-text-subject",
        add: false,
        id: 1,
      },
      {
        name: "Prénom",
        back_name: "first_name_active",
        optionnal: false,
        form_picture: "mdi mdi-text-subject",
        add: false,
        id: 2,
      },
      {
        name: "Adresse mail",
        back_name: "email_active",
        optionnal: false,
        form_picture: "mdi mdi-text-subject",
        add: false,
        id: 3,
      },
      {
        name: "Numéro de téléphone",
        back_name: "phone_active",
        optionnal: false,
        form_picture: "mdi mdi-numeric",
        add: false,
        id: 4,
      },
      {
        name: "Liens",
        back_name: "social_networks_active",
        optionnal: false,
        form_picture: "mdi mdi-link-variant",
        add: false,
        id: 5,
      },
      {
        name: "Lettre de motivation",
        back_name: "motivation_text_active",
        optionnal: false,
        form_picture: "mdi mdi-text-subject",
        add: false,
        id: 6,
      },
      {
        name: "CV",
        back_name: "cv_active",
        optionnal: false,
        form_picture: "mdi mdi-file-multiple-outline",
        add: false,
        id: 7,
      },
      {
        name: "Niveau d'étude",
        back_name: "level_of_study_active",
        optionnal: false,
        form_picture: "mdi mdi-text-subject",
        add: false,
        id: 8,
      },
      {
        name: "Expérience",
        back_name: "experience_active",
        optionnal: false,
        form_picture: "mdi mdi-text-subject",
        add: false,
        id: 9,
      },
      {
        name: "Disponibilité",
        back_name: "availability_active",
        optionnal: false,
        form_picture: "mdi mdi-calendar-month",
        add: false,
        id: 10,
      },
      {
        name: "Salaire souhaité (brut par an)",
        back_name: "salary_active",
        optionnal: false,
        form_picture: "mdi mdi-numeric",
        add: false,
        id: 11,
      },
    ];
  },

  // summary : Function that get an apply form wish is link to a recruitment
  // params : - id_recruitment : recruitment that contain de good apply form

  async get_apply(id_recruitment) {
    let apply;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API + "applies/?recruitment=" + id_recruitment,
    })
      .then((response) => {
        apply = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return apply;
  },

  // summary : Function that create an apply form
  // params : - form : object that contain the apply form

  async create_apply(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "applies/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  // summary : Function that edit an apply form
  // params : - id : Aplly that we want to edit
  //          - form_apply : new form that we want to put in the apply form

  async edit_apply(id, form_apply) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "applies/" + id + "/",
      data: form_apply,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Action = {
  ...service("cvtech-tasks"),

  get_form_action() {
    return {
      cvtech: null,
      title: null,
      desc: null,
      start: null,
      end: null,
      finished: false,
      priority: false,
      hover: false,
    };
  },

  async get_actions() {
    let actions;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "actions",
    })
      .then((response) => {
        actions = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return actions;
  },

  async get_my_actions(user) {
    let actions;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "actions?assigned_user=" + user,
    })
      .then((response) => {
        actions = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return actions;
  },

  async get_actions_by_cv_id(cv_id) {
    let actions;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "actions?cvtech=" + cv_id,
    })
      .then((response) => {
        actions = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return actions;
  },

  async create_action(form_action) {
    let action_form;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "actions/",
      data: form_action,
    })
      .then((response) => {
        action_form = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return action_form;
  },

  async edit_action(id, form_action) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "actions/" + id + "/",
      data: form_action,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_action(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "actions/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Note = {
  ...service("cvtech-notes"),

  get_form_note() {
    return {
      cvtech: null,
      text: null,
      pin: false,
    };
  },

  async get_notes_by_cv_id(cv_id) {
    let notes;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "notes?cvtech=" + cv_id,
    })
      .then((response) => {
        notes = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return notes;
  },

  async create_note(form_note) {
    let note_form;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "notes/",
      data: form_note,
    })
      .then((response) => {
        note_form = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return note_form;
  },

  async delete_note(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "notes/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_note(id, form_note) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "notes/" + id + "/",
      data: form_note,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Career = {
  ...service("careers"),

  get_form_career() {
    return {
      company_name: null,
      company_desc: null,
      company_location: null,
      company_categorie: null,
      company_creation_date: null,
      company_website: null,
      site_url: null,
      linkedin_link: null,
      facebook_link: null,
      twitter_link: null,
      instagram_link: null,
      youtube_link: null,
      presentation_text_one: null,
      presentation_text_two: null,
      looking_for: null,
      good_to_know_text_one: null,
      good_to_know_text_two: null,
      employee_amount: null,
      man_amout: null,
      women_amout: null,
      middle_age: null,
      link_video_one: null,
      link_video_two: null,
      link_video_three: null,
      company_value_text_one: null,
      company_value_text_two: null,
      presentation_picture_one: "",
      presentation_picture_two: "",
      good_to_know_picture_one: "",
      good_to_know_picture_two: "",
      profile_picture: "",
      background_picture: "",
    };
  },

  async get_career() {
    let form_career;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "careers/",
    })
      .then((response) => {
        form_career = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_career;
  },

  async get_career_public() {
    let form_career;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "careers/",
      headers: {
        via: "public",
      },
    })
      .then((response) => {
        console.log("career app", response);
        form_career = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_career;
  },

  async get_client_object(company_slug) {
    let client_object;
    console.log(company_slug);
    console.log(
      process.env.VUE_APP_API + "get_applications?company_slug=" + company_slug
    );
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_API +
        "get_applications?company_slug=" +
        company_slug,
    })
      .then((response) => {
        client_object = response.data;
        console.log("client object :", response);
      })
      .catch((error) => {
        console.log(error);
      });
    return client_object;
  },

  async get_client_token(client_object) {
    let access_token;
    await axios({
      method: "post",
      url: process.env.VUE_APP_AUTHDOMAIN,
      data: qs.stringify({
        client_id: client_object.client_id,
        client_secret: client_object.client_secret,
        grant_type: "client_credentials",
      }),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    })
      .then((response) => {
        access_token = response.data.access_token;
      })
      .catch((error) => {
        console.log(error);
      });
    return access_token;
  },

  async get_company_token(company_slug) {
    let client_object, access_token;
    client_object = await this.get_client_object(company_slug);
    access_token = await this.get_client_token(client_object);
    return access_token;
  },

  async create_career(form_carrer) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "careers/",
      data: form_carrer,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_career(id, form_career) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "careers/" + id + "/",
      data: form_career,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const State = {
  ...service("state-recruitments"),

  get_form_state() {
    return {
      states_recruitment: null,
      name: null,
      company: null,
      state_number: null,
      pipeline: null,
      email_auto: false,
      email_object: null,
      email_text: null,
      email: null,
    };
  },

  get_all_state_number() {
    return {
      state_one_name: null,
      state_two_name: null,
      state_three_name: null,
      state_four_name: null,
      state_five_name: null,
      state_six_name: null,
      state_seven_name: null,
      state_eight_name: null,
    };
  },

  async get_state(id) {
    let form;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "states" + "/?id=" + id,
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  async get_state_by_number(id, number) {
    let form;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "states?pipeline=" +
        id +
        "&state_number=" +
        number,
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  async create_state(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "states/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const State_recruitment = {
  ...service("state-recruitments"),

  get_form_state_recruitment() {
    return {
      recruitement: null,
      cv: null,
      pipeline: null,
      state: null,
      reason_refusal: null,
    };
  },

  get_reason_refusal_choices() {
    return [
      { value: "other", text: "Autre" },
      { value: "distance", text: "Distance" },
      { value: "salary", text: "Salaire" },
      { value: "other_project", text: "Autre projet" },
    ];
  },

  get_fired_by_company_choices() {
    return [
      { value: false, text: "Le candidat" },
      { value: true, text: "L'entreprise" },
    ];
  },

  async get_state_recruitment(id) {
    let form;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "state-recruitments" + "/?id=" + id,
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  async get_state_recruitment_by_state_cv_recruitment(
    id_state,
    id_cv,
    id_recruitment
  ) {
    let form_state_recruitment;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "state-recruitments?state=" +
        id_state +
        "&cv=" +
        id_cv +
        "&recruitment=" +
        id_recruitment,
    })
      .then((response) => {
        form_state_recruitment = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_state_recruitment;
  },

  async create_state_recruitment(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "state-recruitments/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_state_recruitment_public(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "state-recruitments/",
      data: form,
      headers: {
        via: "public",
      },
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_state_recruitment(id, form) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "state-recruitments/" + id + "/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Folder = {
  ...service("folders"),

  get_form_folder() {
    return {
      cvtech: null,
      state_folder: null,
      recruitment: null,
      recruitment_name: null,
      made_at: null,
    };
  },

  async get_folders_with_cv(id_cv) {
    let folders;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "folders" + "/?cvtech=" + id_cv,
    })
      .then((response) => {
        folders = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return folders;
  },

  async get_folder(id_cv, id_recruitment) {
    let form;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "folders" +
        "/?cvtech=" +
        id_cv +
        "&recruitment=" +
        id_recruitment,
    })
      .then((response) => {
        form = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form;
  },

  async create_folder(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "folders/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_folder_public(form) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "folders/",
      data: form,
      headers: {
        via: "public",
        "content-type": "application/json",
      },
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const State_folder = {
  ...service("state-folders"),

  get_form_state_folder() {
    return {
      before_moving: null,
      after_moving: null,
      folder: null,
    };
  },

  async create_state_folder(form) {
    axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "state-folders/",
      data: form,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Interview = {
  ...service("interviews"),

  get_form_interview() {
    return {
      cvtech: null,
      recruitment: null,
      recruitment_name: null,
      title: null,
      desc: null,
      start: null,
      end: null,
      email: null,
      email_auto: null,
      type: null,
    };
  },

  // summary : Function that return a list that contain all the interviews
  // params : none

  async get_interviews() {
    let interviews;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "interviews",
    })
      .then((response) => {
        interviews = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return interviews;
  },

  async get_interview_by_cv(id) {
    let interviews;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "interviews/?cvtech=" + id,
    })
      .then((response) => {
        interviews = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return interviews;
  },

  async get_my_interviews(user) {
    let interviews;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "interviews?assigned_user=" + user,
    })
      .then((response) => {
        interviews = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return interviews;
  },

  // summary : Function that create an interview
  // form_interview : form that contain interview information

  async create_interview(form_interview) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "interviews/",
      data: form_interview,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_interview(id, form_interview) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "interviews/" + id + "/",
      data: form_interview,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_interview(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "interviews/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Filter_cvtech = {
  ...service("filter-cvtechs"),

  get_form_filter_cvtech() {
    return {
      salary: null,
      level_of_study: null,
      experience: null,
      candidate_profile: null,
      address: null,
      strong_points: null,
      activity_area: null,
      type_of_work: null,
      work_address: null,
      profession: null,
      speciality: null,
    };
  },

  // summary : Function that return a list that contains your filter
  // params : - request : url of your request

  async get_filter() {
    let filterCvtech;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "filter-cvtechs",
    })
      .then((response) => {
        filterCvtech = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return filterCvtech;
  },

  // summary : Function that edit a given filter
  // params : - id : filter that we want to edit
  //          - filterRecruitment : object that contain the filters

  async edit_filter(id, filterCvtech) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "filter-cvtechs/" + id + "/",
      data: filterCvtech,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_filter(filterCvtech) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "filter-cvtechs/",
      data: filterCvtech,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Diffusion = {
  ...service("diffusions"),

  get_form_diffusion() {
    return {
      diffusions: [],
    };
  },

  // summary : Function that return a list that contains your filter
  // params : - request : url of your request

  async get_diffusion() {
    console.log("okk");
    let form_diffusion;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "diffusions",
    })
      .then((response) => {
        form_diffusion = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return form_diffusion;
  },

  // summary : Function that edit a given filter
  // params : - id : filter that we want to edit
  //          - filterRecruitment : object that contain the filters

  async edit_diffusion(id, form_diffusion) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "diffusions/" + id + "/",
      data: form_diffusion,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_diffusion(form_diffusion) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "diffusions/",
      data: form_diffusion,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_diffusion(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "diffusions/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Diffusion_choice = {
  ...service("diffusion-choices"),

  get_form() {
    return {
      name: "",
      description: "",
      is_active: true,
      is_chargeable: true,
      logo: null,
    };
  },

  get_form_diffusion_choices() {
    return {
      title: null,
      description: null,
      category: null,
    };
  },

  async get_diffusion_choices() {
    let diffusion_choices;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "diffusion-choices",
    })
      .then((response) => {
        diffusion_choices = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return diffusion_choices;
  },

  async get_diffusion_choices_by_id() {
    let form_diffusion_choices;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "diffusion-choices/" + id,
    })
      .then((response) => {
        form_diffusion_choices = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_diffusion_choices;
  },
};

const Diffusion_category = {
  ...service("diffusion-categories"),

  get_form_diffusion_category() {
    return {
      name: null,
    };
  },

  async get_diffusion_categories() {
    let diffusion_categories;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "diffusion-categories",
    })
      .then((response) => {
        diffusion_categories = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return diffusion_categories;
  },
};

const Tech = {
  ...service("techs"),

  get_form_tech() {
    return {
      techs: [],
    };
  },

  // summary : Function that return a list that contains your filter
  // params : - request : url of your request

  async get_tech() {
    let form_tech;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "techs",
    })
      .then((response) => {
        form_tech = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_tech;
  },

  async get_tech_public() {
    let form_tech;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "techs/",
      headers: {
        via: "public",
      },
    })
      .then((response) => {
        form_tech = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_tech;
  },

  // summary : Function that edit a given filter
  // params : - id : filter that we want to edit
  //          - filterRecruitment : object that contain the filters

  async edit_tech(id, form_tech) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "techs/" + id + "/",
      data: form_tech,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_tech(form_tech) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "techs/",
      data: form_tech,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_tech(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "techs/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Tech_choice = {
  ...service("tech-choices"),

  get_form_tech_choices() {
    return {
      title: null,
      description: null,
      category: null,
    };
  },

  async get_tech_choices() {
    let tech_choices;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "tech-choices",
    })
      .then((response) => {
        tech_choices = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return tech_choices;
  },

  async get_tech_choices_by_id(id) {
    let form_tech_choices;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "tech-choices/" + id,
    })
      .then((response) => {
        form_tech_choices = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return form_tech_choices;
  },
};

const Tech_category = {
  ...service("tech-categories"),

  get_form_tech_category() {
    return {
      name: null,
    };
  },

  async get_tech_categories() {
    let tech_categories;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "tech-categories",
    })
      .then((response) => {
        tech_categories = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return tech_categories;
  },
};

const Label = {
  ...service("labels"),

  get_form_label() {
    return {
      labels: [],
    };
  },

  // summary : Function that return a list that contains your filter
  // params : - request : url of your request

  async get_label() {
    let form_label;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "labels",
    })
      .then((response) => {
        form_label = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_label;
  },

  async get_label_public() {
    let form_label;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "labels/",
      headers: {
        via: "public",
      },
    })
      .then((response) => {
        form_label = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return form_label;
  },

  // summary : Function that edit a given filter
  // params : - id : filter that we want to edit
  //          - filterRecruitment : object that contain the filters

  async edit_label(id, form_label) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "labels/" + id + "/",
      data: form_label,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async create_label(form_label) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "labels/",
      data: form_label,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_label(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "labels/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Label_choice = {
  ...service("label-choices"),

  get_form_label_choices() {
    return {
      title: null,
      description: null,
      category: null,
    };
  },

  async get_label_choices() {
    let label_choices;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "label-choices",
    })
      .then((response) => {
        label_choices = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return label_choices;
  },

  async get_label_choices_by_id(id) {
    let form_label_choices;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "label-choices/" + id,
    })
      .then((response) => {
        form_label_choices = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return form_label_choices;
  },
};

const Label_category = {
  ...service("label-choices"),

  get_form_label_category() {
    return {
      name: null,
    };
  },

  async get_label_categories() {
    let label_categories;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "label-categories",
    })
      .then((response) => {
        label_categories = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return label_categories;
  },
};

const User_me = {
  get_form_user_me() {
    return {
      email: null,
      first_name: null,
      last_name: null,
      profile_picture: null,
    };
  },

  async get_user_me() {
    let form_user_me;
    await axios({
      method: "get",
      url: process.env.VUE_APP_API + "users/me",
    })
      .then((response) => {
        form_user_me = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return form_user_me;
  },
};

const User = {
  get_form_user_invite() {
    return {
      email: null,
      first_name: null,
      last_name: null,
      group: 1,
    };
  },

  async get_users() {
    let users;
    await axios({
      method: "get",
      url: process.env.VUE_APP_API + "users",
    })
      .then((response) => {
        users = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return users;
  },

  async user_invite(form_user_invite) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_API + "users/invite/",
      data: form_user_invite,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Comment = {
  ...service("cvtech-comments"),

  get_form_comment() {
    return {
      user: null,
      cvtech: null,
      comment: null,
    };
  },

  async get_comments() {
    let comments;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "comments/",
    })
      .then((response) => {
        comments = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return comments;
  },

  async get_comments_by_cv_id(cv_id) {
    let comments;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "comments?cvtech=" + cv_id,
    })
      .then((response) => {
        comments = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return comments;
  },

  async create_comment(form_comment) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "comments/",
      data: form_comment,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_comment(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "comments/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_comment(id, form_comment) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "comments/" + id + "/",
      data: form_comment,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Cvtech_document = {
  ...service("cvtech-documents"),

  get_form_cvtech_document() {
    return {
      cvtech: null,
      document: null,
      title: null,
      size: null,
    };
  },

  async get_cvtech_documents() {
    let documents;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtech-documents/",
    })
      .then((response) => {
        documents = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return documents;
  },

  async get_cvtech_documents_by_cv_id(cv_id) {
    let documents;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtech-documents?cvtech=" + cv_id,
    })
      .then((response) => {
        documents = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return documents;
  },

  async create_cvtech_document(form_cvtech_document) {
    let document;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "cvtech-documents/",
      data: form_cvtech_document,
    })
      .then((response) => {
        document = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async delete_cvtech_document(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "cvtech-documents/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Cvtech_cover_letter = {
  ...service("cvtech-cover-letters"),

  get_form_cvtech_cover_letter() {
    return {
      cvtech: null,
      document: null,
      title: null,
      size: null,
    };
  },

  async get_cvtech_cover_letter() {
    let document;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtech-cover-letters/",
    })
      .then((response) => {
        document = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async get_cvtech_cover_letter_by_cv_id(cv_id) {
    let document;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtech-cover-letters?cvtech=" + cv_id,
    })
      .then((response) => {
        document = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async create_cvtech_cover_letter(form_cvtech_cover_letter) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "cvtech-cover-letters/",
      data: form_cvtech_cover_letter,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_cvtech_cover_letter(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "cvtech-cover-letters/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Recruitment_company_banner = {
  ...service("recruitment-company-banners"),

  get_form_recruitment_company_banner() {
    return {
      recruitment: null,
      document: null,
      title: null,
      size: null,
    };
  },

  async get_recruitment_company_banner() {
    let document;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitment-company-banners/",
    })
      .then((response) => {
        document = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async get_recruitment_company_banner_with_recruitment_id(recruitment_id) {
    let document;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "recruitment-company-banners?recruitment=" +
        recruitment_id,
    })
      .then((response) => {
        document = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async create_recruitment_company_banner(form_recruitment_company_banner) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "recruitment-company-banners/",
      data: form_recruitment_company_banner,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_recruitment_company_banner(id, form_recruitment_company_banner) {
    await axios({
      method: "put",
      url:
        process.env.VUE_APP_ATS_API + "recruitment-company-banners/" + id + "/",
      data: form_recruitment_company_banner,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_recruitment_company_banner(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "recruitment-company-banners/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Recruitment_company_image = {
  ...service("recruitment-company-images"),

  get_form_recruitment_company_image() {
    return {
      recruitment: null,
      document: null,
      title: null,
      size: null,
    };
  },

  async get_recruitment_company_image() {
    let document;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitment-company-images/",
    })
      .then((response) => {
        document = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async get_recruitment_company_image_with_recruitment_id(recruitment_id) {
    let document;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "recruitment-company-images?recruitment=" +
        recruitment_id,
    })
      .then((response) => {
        document = response.data.results[0];
      })
      .catch((error) => {
        console.log(error);
      });
    return document;
  },

  async create_recruitment_company_image(form_recruitment_company_image) {
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "recruitment-company-images/",
      data: form_recruitment_company_image,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async edit_recruitment_company_image(id, form_recruitment_company_image) {
    await axios({
      method: "put",
      url:
        process.env.VUE_APP_ATS_API + "recruitment-company-images/" + id + "/",
      data: form_recruitment_company_image,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_recruitment_company_image(id) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "recruitment-company-images/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Email = {
  ...service("emails"),

  get_form_email() {
    return {
      user: null,
      company: null,
      title: null,
      category: null,
      object: null,
      text: null,
    };
  },

  get_category_choices() {
    return [
      { value: "state", text: "Étape de pipeline" },
      { value: "interview", text: "Entretien d'embauche" },
    ];
  },

  async get_emails() {
    let emails;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "emails",
    })
      .then((response) => {
        emails = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return emails;
  },

  async get_emails_by_category(category) {
    let emails;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "emails?category=" + category,
    })
      .then((response) => {
        emails = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return emails;
  },

  async get_emails_with_request(request) {
    let emails;
    await axios({
      method: "get",
      url: request,
    })
      .then((response) => {
        emails = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return emails;
  },

  async create_email(form_email) {
    let email_form;
    await axios({
      method: "post",
      url: process.env.VUE_APP_ATS_API + "emails/",
      data: form_email,
    })
      .then((response) => {
        email_form = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return email_form;
  },

  async edit_email(id_email, form_email) {
    await axios({
      method: "put",
      url: process.env.VUE_APP_ATS_API + "emails/" + id_email + "/",
      data: form_email,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },

  async delete_email(id_email) {
    await axios({
      method: "delete",
      url: process.env.VUE_APP_ATS_API + "emails/" + id_email + "/",
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  },
};

const Graph = {
  get_month_choices() {
    return [
      {
        value: "01",
        text: "Janvier",
      },
      {
        value: "02",
        text: "Février",
      },
      {
        value: "03",
        text: "Mars",
      },
      {
        value: "04",
        text: "Avril",
      },
      {
        value: "05",
        text: "Mai",
      },
      {
        value: "06",
        text: "Juin",
      },
      {
        value: "07",
        text: "Juillet",
      },
      {
        value: "08",
        text: "Août",
      },
      {
        value: "09",
        text: "Septembre",
      },
      {
        value: "10",
        text: "Octobre",
      },
      {
        value: "11",
        text: "Novembre",
      },
      {
        value: "12",
        text: "Décembre",
      },
    ];
  },

  get_params_filter_date() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: null,
      selectedYearEnd: null,
      selectedMonthEnd: null,
    };
  },

  get_donut_chart() {
    return {
      series: [],
      chartOptions: {
        labels: [],
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return val.toFixed(1) + "%";
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 400,
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    let sum = 0;
                    for (let i = 0; i < val.globals.series.length; i++) {
                      sum = sum + val.globals.series[i];
                    }
                    return sum;
                  },
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
      total: 0,
    };
  },

  get_bar_chart_vertical() {
    return {
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#465BFD"],
        grid: {
          borderColor: "#f1f1f1",
        },
        xaxis: {
          categories: [],
        },
      },
      total: 0,
    };
  },

  get_bar_chart() {
    return {
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#465BFD"],
        grid: {
          borderColor: "#f1f1f1",
        },
        xaxis: {
          categories: [],
        },
      },
      total: 0,
    };
  },

  get_linewidth_chart() {
    return {
      chartOptions: {
        chart: {
          height: 380,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [3, 3],
          curve: "straight",
        },
        title: {
          text: ".",
          align: "left",
          style: {
            fontWeight: "500",
          },
        },
        grid: {
          row: {
            colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.2,
          },
          borderColor: "#f1f1f1",
        },
        markers: {
          style: "inverted",
          size: 6,
        },
        xaxis: {
          categories: [],
          title: {
            text: "Mois",
          },
        },
        yaxis: {
          title: {
            text: "Candidats",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                toolbar: {
                  show: false,
                },
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
      series: [],
      total: 0,
    };
  },

  async get_graph(graph, request) {
    let result;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + graph + request,
    })
      .then((response) => {
        result = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  },

  async get_recruitment_stats(request) {
    let recruitment_stats;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitment-stats" + request,
    })
      .then((response) => {
        recruitment_stats = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return recruitment_stats;
  },

  formatDateFilter(params) {
    let selectedDate;
    let selectedDateEnd = null;

    if (params.selectedMonth != null) {
      selectedDate = params.selectedYear + "-" + params.selectedMonth + "-01";
    } else {
      selectedDate = params.selectedYear + "-01-01";
    }

    if (params.selectedMonthEnd != null) {
      if (params.selectedYearEnd != null) {
        selectedDateEnd =
          params.selectedYearEnd + "-" + params.selectedMonthEnd + "-01";
      } else {
        selectedDateEnd =
          new Date().getFullYear() + "-" + params.selectedMonthEnd + "-01";
      }
    } else {
      if (params.selectedYearEnd != null) {
        selectedDateEnd = params.selectedYearEnd + "-01-31";
      }
    }

    let beginRequest = "";
    let endRequest = "";

    if (selectedDate != null) {
      beginRequest = "?begin=" + selectedDate;
    } else {
      beginRequest = "";
    }
    if (selectedDateEnd != null) {
      if (selectedDate != null) {
        endRequest = "&end=" + selectedDateEnd;
      } else {
        endRequest = "?end=" + selectedDateEnd;
      }
    } else {
      endRequest = "";
    }

    return beginRequest + endRequest;
  },

  async get_pipeline_candidat_number(request) {
    let pipeline_candidat_number;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "pipeline-candidat-number" + request,
    })
      .then((response) => {
        pipeline_candidat_number = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return pipeline_candidat_number;
  },

  async get_recruitment_candidat_number(request) {
    let recruitment_candidat_number;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API + "recruitment-candidat-number" + request,
    })
      .then((response) => {
        recruitment_candidat_number = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return recruitment_candidat_number;
  },

  async get_candidat_grades(request) {
    let candidat_grades;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "candidat-grades" + request,
    })
      .then((response) => {
        candidat_grades = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return candidat_grades;
  },

  async get_recruitement_time_average(request) {
    let recruitement_time_average;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "recruitment-time-average" + request,
    })
      .then((response) => {
        recruitement_time_average = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return recruitement_time_average;
  },

  async get_general_recruitement_time_average(request) {
    let recruitement_time_average;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "general-recruitment-time-average" +
        request,
    })
      .then((response) => {
        recruitement_time_average = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return recruitement_time_average;
  },

  async get_fired_cvtechs(request) {
    let candidat_grades;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "fired-cvtechs" + request,
    })
      .then((response) => {
        candidat_grades = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return candidat_grades;
  },

  async get_profession_cvtechs(request) {
    let profession_cvtechs;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "profession-cvtechs" + request,
    })
      .then((response) => {
        profession_cvtechs = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return profession_cvtechs;
  },

  async get_speciality_cvtechs(request) {
    let speciality_cvtechs;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "speciality-cvtechs" + request,
    })
      .then((response) => {
        speciality_cvtechs = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return speciality_cvtechs;
  },

  async get_accepted_cvtechs(request) {
    let accepted_cvtechs;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "accepted-cvtechs" + request,
    })
      .then((response) => {
        accepted_cvtechs = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return accepted_cvtechs;
  },

  async get_accepted_cvtechs_by_pipeline(request) {
    let accepted_cvtechs;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API + "accepted-cvtech-by-pipeline" + request,
    })
      .then((response) => {
        accepted_cvtechs = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return accepted_cvtechs;
  },

  async get_accepted_cvtechs_by_recruitment(request) {
    let accepted_cvtechs;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API +
        "accepted-cvtech-by-recruitment" +
        request,
    })
      .then((response) => {
        accepted_cvtechs = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return accepted_cvtechs;
  },

  async get_cvtech_sources(request) {
    let cvtech_sources;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtech-sources" + request,
    })
      .then((response) => {
        cvtech_sources = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return cvtech_sources;
  },

  async get_cvtech_numbers(request) {
    let cvtech_numbers;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "cvtech-numbers" + request,
    })
      .then((response) => {
        cvtech_numbers = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return cvtech_numbers;
  },

  async get_accepted_cvtech_by_source(request) {
    let accepted_cvtech_by_source;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "accepted-cvtech-by-source" + request,
    })
      .then((response) => {
        accepted_cvtech_by_source = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return accepted_cvtech_by_source;
  },

  async get_reason_refusal(request) {
    let reason_refusal;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "reason-refusal" + request,
    })
      .then((response) => {
        reason_refusal = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return reason_refusal;
  },

  async get_candidat_grade_by_recruitment(request) {
    let candidat_grade_by_recruitment;
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_ATS_API + "candidat-grade-by-recruitment" + request,
    })
      .then((response) => {
        candidat_grade_by_recruitment = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return candidat_grade_by_recruitment;
  },

  async get_candidat_grade_by_pipeline(request) {
    let candidat_grade_by_pipeline;
    await axios({
      method: "get",
      url: process.env.VUE_APP_ATS_API + "candidat-grade-by-pipeline" + request,
    })
      .then((response) => {
        candidat_grade_by_pipeline = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return candidat_grade_by_pipeline;
  },
};

module.exports = {
  Recruitment,
  Cvtech,
  Recruitment_team,
  Pipeline,
  Filter_recruitment,
  Apply,
  Action,
  Note,
  Career,
  State,
  State_recruitment,
  Folder,
  State_folder,
  Interview,
  Filter_cvtech,
  Diffusion,
  Diffusion_choice,
  Diffusion_category,
  Tech,
  Tech_choice,
  Tech_category,
  Label,
  Label_choice,
  Label_category,
  User_me,
  User,
  Comment,
  Cvtech_document,
  Cvtech_cover_letter,
  Recruitment_company_banner,
  Recruitment_company_image,
  Email,
  Graph,
  Report,
};
